<script setup>
import BildapButton from "@/components/BildapButton.vue";

const pageLabelPrefix = 'not_found.';
</script>

<template>
  <div class="wrapper-simpatia">
    <h1 class="numerone">{{ $t(pageLabelPrefix + 'title') }}</h1>
    <h2 class="zelig">{{ $t(pageLabelPrefix + 'subtitle') }}</h2>
    <bildap-button class="b-inverted" :label="$t(pageLabelPrefix+'go_home')" to="/"></bildap-button>
  </div>
</template>

<style lang="less" scoped>
.wrapper-simpatia {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.numerone {
  font-family: "AktivGroteskEx", Serif;
  font-size: 300px;
  color: @font-color;
}

.zelig{
  font-family: "AktivGroteskEx", Serif;
  font-weight: 400;
  margin-bottom: 50px;
  text-align: center;
}
.b-inverted{
  margin-bottom: 120px;
}


//MOBILE
.mobile-app{
  .numerone{
    font-size: 20vw;
  }

  .zelig{
    padding: 20px;
    font-size: 18px;
  }
}
</style>